/**
 * Browser-compatible base64 decode and binary read helpers.
 * Avoids Buffer so the library works in both Node and browser.
 */
export function base64ToBytes(b64) {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        bytes[i] = bin.charCodeAt(i);
    }
    return bytes;
}
export function readUInt32LE(buf, offset) {
    return (buf[offset] |
        (buf[offset + 1] << 8) |
        (buf[offset + 2] << 16) |
        (buf[offset + 3] << 24));
}
export function readBigUInt64LE(buf, offset) {
    const lo = BigInt(readUInt32LE(buf, offset));
    const hi = BigInt(readUInt32LE(buf, offset + 4));
    return (hi << BigInt(32)) | lo;
}
//# sourceMappingURL=utils.js.map